module.exports = __webpack_public_path__ + "img/instagram-icon.b6c1c2f9.svg";